import axios from 'axios';

export function tokenVencido(status) {
  if (status == 401) {
    localStorage.setItem('token', '');
    window.location.reload();
  }
}

export function crearClienteConProteccion() {
  const token = localStorage.getItem('token');
  return new Cliente(
    undefined,
    axios.create({
      baseURL: process.env.REACT_APP_URL_API,
      headers: {
        authorization: `Bearer ${token}`
      },
      transformResponse: (data) => data
    })
  );
}
